var Chart = require("chart.js");
var myChart;

$(document).ready(function (e) {
  if (
    $(document).find("#ChangeProfileForm, #KiwisaverApplicationForm").length > 0
  ) {
    var dom = $(document).find("#ChangeProfileForm, #KiwisaverApplicationForm");

    /**
     * Render the confirmation input label
     **/
    var renderLifestagesConfirmation = function () {
      if (confirmation_data) {
        var confirmation = confirmation_data.attr("data-template");
        var type_value = type_input.filter(":checked").val();
        var profile_value = profile_input.filter(":checked").val();

        if (type_value == "Lifestages Auto") {
          confirmation = confirmation.replace("$Profile", "Lifestages Auto");
        } else {
          if (profile_value) {
            // Custom profile builder
            if (profile_value == "Custom") {
              profile_value =
                custom_profile_highgrowth_input.val() +
                "% Lifestages High Growth, " +
                custom_profile_focusedgrowth_input.val() +
                "% Lifestages Focused Growth, " +
                custom_profile_cashfund_input.val() +
                "% Lifestages Cash Fund, " +
                custom_profile_income_input.val() +
                "% Lifestages Income";
            }

            confirmation = confirmation.replace("$Profile", profile_value);
          }
        }

        confirmation_field.find("label").html(confirmation);
        confirmation_data.val($("<span>" + confirmation + "</span>").text());

        // And render the matching chart
        renderProfileAllocationChart();
      }
    };

    // Using the template, render the description text
    var renderLifestagesAutoDescription = function (dob) {
      var description = description_input.attr("data-template");
      // add 1 day to account for birthday today
      var day = new Date();
      var tomorrow = day.setDate(day.getDate() + 1);

      // Convert the jQuery dd/mm/yyyy format into computer-friendly yyyy-mm-dd
      var dob_elements = dob.split("/");
      var dob = new Date(
        dob_elements[2] + "-" + dob_elements[1] + "-" + dob_elements[0]
      );

      // calculate month difference from current date in time
      var month_diff = tomorrow - dob.getTime();

      // convert the calculated difference in date format
      var age_dt = new Date(month_diff);

      // extract year from date
      var year = age_dt.getUTCFullYear();

      //  now calculate the age of the user
      var age = Math.abs(year - 1970);

      // display the calculated age
      // console.log("Age is: " + age + " years.");

      if (age >= 65) {
        lifestages_auto_profile_name = "Age_65";
        var focused_growth_percentage = 0;
        var income_percentage = 55;
        var high_growth_percentage = 30;
        var cash_percentage = 15;
        var age_bracket = "65+";

      } else if (age >= 60) {
        lifestages_auto_profile_name = "Age_60_64";
        var focused_growth_percentage = 0;
        var income_percentage = 50;
        var high_growth_percentage = 40;
        var cash_percentage = 10;
        var age_bracket = "between 60 and 64";
      
      } else if (age >= 55) {
        lifestages_auto_profile_name = "Age_55_59";
        var focused_growth_percentage = 0;
        var income_percentage = 40;
        var high_growth_percentage = 60;
        var cash_percentage = 0;
        var age_bracket = "between 55 and 59";
      
      } else if (age >= 50) {
        lifestages_auto_profile_name = "Age_50_54";
        var focused_growth_percentage = 5;
        var income_percentage = 20;
        var high_growth_percentage = 75;
        var cash_percentage = 0;
        var age_bracket = "between 50 and 54";
      
      } else {
        lifestages_auto_profile_name = "Age_0_49";
        var focused_growth_percentage = 15;
        var income_percentage = 0;
        var high_growth_percentage = 85;
        var cash_percentage = 0;
        var age_bracket = "between 0 and 49";
      }

      description = description.replace("$Age", age);
      description = description.replace("$FocusedGrowthPercentage", focused_growth_percentage);
      description = description.replace("$HighGrowthPercentage", high_growth_percentage);
      description = description.replace("$IncomePercentage", income_percentage);
      description = description.replace("$CashPercentage", cash_percentage);
      description = description.replace("$AgeBracket", age_bracket);

      description_input.html(description);
      description_display.html(description);

      renderProfileAllocationChart();
    };

    /**
     * Render the allocation chart, based on the selected profile
     **/
    var renderProfileAllocationChart = function () {
      var type = dom.find('input[name="ProfileType"]:checked').val();
      var profile_field = dom.find('input[name="InvestmentProfile"]:checked');
      var profile_name = null;
      var chart_dom = dom.find(".allocation-chart__holder");

      // Depending on the profile type, our 'position' changes behavior
      // Custom is ordered low-risk to high-risk, whereas Lifestages Auto is based on
      // age, and thus high-risk to low-risk (as you get older). The order of funds and
      // the allocation data is managed in the CMS
      switch (type) {
        case "Lifestages Auto":
          profile_name = lifestages_auto_profile_name;
          break;

        case "Custom":
          switch (profile_field.val()) {
            case "100% Cash Fund":
              profile_name = "Cash_100_0";
              break;
            case "100% Income Fund":
              profile_name = "Balance_0_100";
              break;
            case "30% High Growth / 55 % Income Fund / 15% Cash Fund":
              profile_name = "Balance_30_55_15";
              break;
            case "40% High Growth / 50% Income Fund / 10% Cash Fund":
              profile_name = "Balance_40_50_10";
              break;
            case "60% High Growth Fund / 40% Income Fund":
              profile_name = "Balance_60_40";
              break;
            case "5% Focused Growth / 75% High Growth / 20% Income":
              profile_name = "Balance_80_20";
              break;
            case "15% Focused Growth Fund / 85% High Growth Fund":
              profile_name = "Balance_15_85";
              break;
            case "100% High Growth Fund":
              profile_name = "Balance_100_0";
              break;
            case "25% Focused Growth Fund":
              profile_name = "Focused_Growth_25";
              break;
          }
          break;
      }

      // If we've got a valid position integer, fetch the chart
      if (profile_name !== null) {
        // Drop on a loader
        chart_dom.html(
          '<div class="loader"><div class="loader__circle"></div></div>'
        );

        $.ajax({
          type: "GET",
          url: $("body").attr("href").replace(/\/?$/, "/") + "chart?ProfileName=" + profile_name,
          success: function (response) {
            if (response) {
              // Inject the response markup
              chart_dom.html(response);

              var allocation_chart = chart_dom.find(
                ".allocation-chart_canvas canvas"
              );
              var allocation_chart_data = {};
              var allocation_chart_object = null;
              if (allocation_chart.length > 0) {
                allocation_chart_data = JSON.parse(
                  allocation_chart.attr("data-json")
                );

                allocation_chart_object = new Chart(allocation_chart, {
                  type: "pie",
                  options: {
                    legend: {
                      position: "left",
                      labels: {
                        fontFamily: "Nunito",
                        fontSize: 14,
                        usePointStyle: true,
                      },
                    },
                    maintainAspectRatio: false, // Important to allow fixed height
                    responsive: true,
                    onResize: function (chart, size) {
                      chart.canvas.parentNode.style.height = "300px"; // Set fixed height for all charts
                    },
                  },
                  data: {
                    labels: allocation_chart_data.Labels,
                    datasets: [
                      {
                        data: allocation_chart_data.Values,
                        backgroundColor: allocation_chart_data.Colours,
                      },
                    ],
                  },
                });

                // Force height immediately after rendering
                allocation_chart_object.canvas.parentNode.style.height = "300px";
              }


            } else {
              // Clear our chart
              chart_dom.html("");
            }
          },
        });
      } else {
        // Clear our chart
        chart_dom.html("");
      }
    };


    /**
     * Custom profile builder
     **/

    var profile_highgrowth_field = dom.find(
      '[name="CustomInvestmentProfile_HighGrowth"]'
    );
    var profile_focusedgrowth_field = dom.find(
      '[name="CustomInvestmentProfile_FocusedGrowth"]'
    );
    var profile_cashfund_field = dom.find(
      '[name="CustomInvestmentProfile_CashFund"]'
    );
    var profile_income_field = dom.find(
      '[name="CustomInvestmentProfile_Income"]'
    );

    // Disable the "Please select..." options
    // profile_highgrowth_field.find('option[value=""]').prop('disabled', true);
    // profile_focusedgrowth_field.find('option[value=""]').prop('disabled', true);
    // profile_cashfund_field.find('option[value=""]').prop('disabled', true);

    // Add minimum value for age
    if (
      profile_highgrowth_field.length > 0 &&
      profile_income_field.length > 0
    ) {
      profile_highgrowth_field.on("change", function (e) {
        calculateCustomProfile();
        // profile_focusedgrowth_field.prop('disabled', false);
      });

      profile_focusedgrowth_field.on("change", function (e) {
        calculateCustomProfile();
        // profile_cashfund_field.prop('disabled', false);
      });

      profile_cashfund_field.on("change", function (e) {
        calculateCustomProfile();
      });

      // Calculate on load
      calculateCustomProfile();
    }

    function calculateCustomProfile() {
      var highGrowthValue = Number(profile_highgrowth_field.val() || 0);
      var focusedGrowthValue = Number(profile_focusedgrowth_field.val() || 0);
      var cashFundValue = Number(profile_cashfund_field.val() || 0);

      var balance = 100 - (highGrowthValue + focusedGrowthValue + cashFundValue);

      // if (balance < 0) {
      //   console.log("Error: Total allocation exceeds 100%");
      //   console.log("Resetting all values to 0");
      //   highGrowthValue.val('0');
      //   profile_focusedgrowth_field.val('0');
      //   profile_cashfund_field.val('0');
      // }

      profile_income_field.find("option").removeAttr("selected");
      profile_income_field
        .find('option[value="' + balance + '"]')
        .attr("selected", "selected");

      // Update Focused Growth dropdown options
      updateDropdownOptions(
        profile_highgrowth_field,
        100 - focusedGrowthValue - cashFundValue,
        focusedGrowthValue
      );

       // Update Focused Growth dropdown options
      updateDropdownOptions(
        profile_focusedgrowth_field,
        100 - highGrowthValue - cashFundValue,
        focusedGrowthValue
      );
      
      // Update Cash Fund dropdown options
      updateDropdownOptions(
        profile_cashfund_field,
        100 - highGrowthValue - focusedGrowthValue,
        cashFundValue
      ); 

      renderLifestagesConfirmation();
      renderProfileAllocationChart();
    }

    function updateDropdownOptions(dropdown, maxAllowed, currentValue) {
      dropdown.find("option").each(function() {
        var optionValue = Number($(this).val());
        
        // Skip the currently selected option to avoid locking the user
        if (optionValue === currentValue) {
          $(this).prop("disabled", false);
          return;
        }
        
        // Disable options that would cause total to exceed 100%
        if (optionValue > maxAllowed) {
          $(this).prop("disabled", true);
        } else {
          $(this).prop("disabled", false);
        }
      });
    }

    /**
     * Confirmation of profile type
     * Changes the checkbox label dependent of the type
     **/

    var type_input = dom.find('input[name="ProfileType"]');
    var profile_input = dom.find('input[name="InvestmentProfile"]');
    
    var custom_profile_highgrowth_input = dom.find(
      '[name="CustomInvestmentProfile_HighGrowth"]'
    );
    var custom_profile_focusedgrowth_input = dom.find(
      '[name="CustomInvestmentProfile_FocusedGrowth"]'
    );
    var custom_profile_cashfund_input = dom.find(
      '[name="CustomInvestmentProfile_CashFund"]'
    );
    var custom_profile_income_input = dom.find(
      '[name="CustomInvestmentProfile_Income"]'
    );
    var confirmation_field = dom
      .find('input[name="InvestmentProfileConfirmed"]')
      .closest(".field");

    var confirmation_data = dom.find(
      'input[name="InvestmentProfileConfirmation"]'
    );

    // Re-render on change of profile type (Lifestages Auto vs Custom)
    type_input.on("change", function (e) {
      renderLifestagesConfirmation();
    });

    // Re-render on change of custom, pre-built profile
    profile_input.on("change", function (e) {
      renderLifestagesConfirmation();
    });

    // Render on load
    renderLifestagesConfirmation();

    /**
     * Lifestages Auto description
     *
     * This field auto-selects a fund based on a person's age. We also need to
     * render a custom output of the age range, profile and run detection on minimum
     * age requirements
     **/

    var dob_field = dom.find('input[name="DateOfBirth"]');
    var description_input = dom.find('[name="LifestagesAutoDescription"]');
    var description_display = dom.find("#LifestagesAutoDescription_display");
    var lifestages_auto_profile_name = null;

    // Add minimum value for age
    if (dob_field.not(".dob").length > 0) {
      dob_field.not(".dob").rules("add", {
        eighteenYearsAgo: true,
        messages: {
          eighteenYearsAgo:
            "Members aged below 18 are unable to use this online form.  Please refer to <a href='http://www.sbswealth.co.nz' target='_blank'>sbswealth.co.nz <i class='fa fa-external-link'></i></a> for the paper-based form.  Please call us on 0800 727 935 if you require any help.",
        },
      });
    }

    // Make sure we have all the required elements before we do anything
    if (
      dob_field.length > 0 &&
      description_input.length > 0 &&
      description_display.length > 0
    ) {
      // Re-render on change of date
      dob_field.on("change", function (e) {
        renderLifestagesAutoDescription(e.target.value);
      });

      // Render on load
      renderLifestagesAutoDescription(dob_field.val());
    }
  }
});
